<p-autocomplete #searchbar [fluid]="true" [overlayOptions]="overlayOptions" [(ngModel)]="searchQuery" [appendTo]="searchResultsContainer" (completeMethod)="search()" field="innerText" [dropdown]="true" [dropdownIcon]="'pi pi-search'" placeholder="Zoeken" [minLength]="3" [showClear]="true" (onSelect)="onSelect($event)">
    <ng-template let-result pTemplate="item">
        <div class="p-clearfix">
            <a [href]="result.route.path">{{result.route.title}}</a>
            <dynamic-template *ngIf="result" [content]="result.innerText | highlightSearch: searchQuery"></dynamic-template>
        </div>
    </ng-template>
    <ng-template></ng-template>
</p-autocomplete>
<div #searchResultsContainer [style]="{ 'position': 'relative' }">
    <div class="search-results" *ngIf="searchResults.length > 0">
        <p-table [value]="searchResults" [paginator]="true" [rows]="5" [rowsPerPageOptions]="[5,10,20]" [showCurrentPageReport]="true">
            <ng-template #header>
                <tr>
                    
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-result>
                <tr>
                    <td><a [href]="result.route.path">{{result.route.title}}</a></td>
                    <td><dynamic-template *ngIf="result" [content]="result.innerText | highlightSearch: searchQuery"></dynamic-template></td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="search-results" *ngIf="searchResults.length === 0 && searchQuery.length > 0">
        <div class="search-result">
            <p>No results found</p>
        </div>
    </div>

</div>